module.exports = __webpack_public_path__ + "img/bus_bell-on.34922095.svg";